/* tslint:disable */
 
import { FileModel } from './file-model';
import { FontEntryDto } from './font-entry-dto';
import { LocalizedValue } from './localized-value';
import { MobileColorsCustomizations } from './mobile-colors-customizations';
export class ThemeEntryDto {
  dark_colors_mobile_customization?: MobileColorsCustomizations;
  dark_mode?: boolean;
  general_css?: null | FileModel;
  id?: string;
  light_colors_mobile_customization?: MobileColorsCustomizations;
  mobile_selected_font?: FontEntryDto;
  theme_name: LocalizedValue;
  used_font?: Array<FontEntryDto>;
}
